module.exports = __webpack_public_path__ + "static/media/sergio-174.dc23663e.jpg";